<template>
  <div id="contain-popup" v-if="componentName">
    <component :is="componentName" :props="dataComponent"></component>
  </div>
</template>
<script setup>
import { useRouter, useRoute } from 'vue-router';
import { ModuleContext, ModulePopup } from '@/stores/moduleConst';
import { computed, watch } from 'vue';
import { useStore } from 'vuex';
import { ModuleDialog } from '@/stores/moduleConst';
import { POPUP } from '@/constants';
    const store = useStore();
    let componentName = computed(() =>
      SetUpComponent(store.state[ModulePopup].type)
    );
    let dataComponent = computed(() => store.state[ModulePopup].data);
    //function
    function SetUpComponent(commandName) {
      switch (typeof(commandName)) {
        case 'string':
          return commandName;
        default:
          return null;
      }
    }
</script>
<style lang="scss">
#contain-popup {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 99999999999999999999999998;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
